//引入axios
import axios from 'axios'
import qs from 'qs'


//服务器切换
const IP = '../qvbian';  // 线上
// const IP = 'http://192.168.1.245:9288/qvbian';  // 测试

// axios 配置
axios.defaults.timeout = 10000
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.get['Content-Type'] = 'application/json'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true
axios.defaults.baseURL = IP;

//请求之前处理参数
//添加loading状态
axios.interceptors.request.use((config) => {
  if (config.method === 'post' && config.headers.hasOwnProperty('Content-Type')) {
    config.data = JSON.stringify(config.data)
  }else if(config.method === 'post'){
    config.data = qs.stringify(config.data)
  }else if(config.method === 'get' && config.headers.hasOwnProperty('Content-Type')){
    config.data = JSON.stringify(config.data)
  }else if(config.method === 'get'){
    config.data = qs.stringify(config.data)
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

//统一处理返回状态
axios.interceptors.response.use(config=>{
  if(config.data.status === -1){
    //未登录暂不统一处理
    localStorage.removeItem('userInfo');
    window.location = 'register.html';
  }else if(config.data.status === 0){
    // msgError('系统异常！');
  }
  return config
},error=>{
  return Promise.reject(error)
});

//post请求头一
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


// post请求头二
export function fetch (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {params})
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function geter (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url,params,{headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const indexApi = {
  //获取首页banner
  getHomepageBanner(params) {
    return get('/api/getHomepageBanner',params)
  },
  //获取首页视频案例
  getHomepWorkSample(params) {
    return get('/api/getHomepWorkSample',params)
  },
  //获取首页制作人
  getHomepageProducer(params){
    return get('/api/getHomepageProducer',params)
  },
  //获取首页展示的演员及模特
  getHomepageModelActor(params){
    return get('/api/getHomepageModelActor',params)
  },
  //获取首页资讯列表
  getHomepageInformation(params){
    return get('/api/getHomepageInformation',params)
  },
  //获取首页活动
  getHomepageActivity(params){
    return get('/api/getHomepageActivity',params)
  },
  //获取资讯列表
  getInformationByPage(p){
    return get('/api/getInformationByPage',p)
  },
  //id获取资讯详情
  getInformationDetail(p){
    return get('/api/getInformationDetail',p)
  },
  //获取首页模块
  getHomepageModule(p){
    return get('/api/getHomepageModule',p)
  }
};

//案例展示
const caseIndex = {
  //读消息
  apiAccountsetMsgRead(p){
    return get('/api/account/setMsgRead',p)
  },
  //分页获取视频案例
  getWorkSampleByPage(params){
    return get('/api/getWorkSampleByPage',params)
  },
  //案例详情
  getWorkSampleDetail(params){
    return get('/api/getWorkSampleDetail',params)
  },
  //发送评论
  postSampleComment(params){
    return fetch('/api/account/postSampleComment',params)
  },
  //客户评论
  postCommentComment(p){
    return fetch('/api/account/postCommentComment',p)
  },
  //获取更多评论
  getSampleCommentByPage(params){
    return get('/api/getSampleCommentByPage',params)
  },
  //删除评论
  deleteSampleComment(p){
    return get('/api/account/deleteSampleComment',p)
  },
  //播放次数
  apiIncreasePlayCount(params){
    return get('/api/increasePlayCount',params)
  },
  //点赞
  apiAccountSetLikeForSample(params){
    return get('/api/account/setLikeForSample',params)
  },
  //邀请
  apiPostConsumerIntention(params){
    return post('/api/postConsumerIntention',params)
  },

  //消息列表
  msgList(p){
    return get('/api/account/msgList',p)
  },
  //删除消息
  deleteMsg(p){
    return get('/api/account/deleteMsg',p)
  },
  //制作人收藏列表
  producerKeepList(p){
    return get('/api/account/producerKeepList',p)
  },
  //收藏取消收藏制作人
  producerKeep(p){
    return get('/api/account/producerKee',p)
  },
  //视频案例收藏列表
  workSampleKeepList(p){
    return get('/api/account/workSampleKeepList',p)
  },
  //收藏案例
  apiAccountWorkSampleKeep(p){
    return get('/api/account/workSampleKeep',p)
  },
  //艺人收藏列表
  modelKeepList(p){
    return get('/api/account/modelKeepList',p)
  },
  //收藏取消艺人
  modelKeep(p){
    return get('/api/account/modelKeep',p)
  }
};
//登录注册
const apiReg = {
  //
  accountWeixinOpenBind(p){
    return get('/api/account/weixinOpenBind',p)
  },
  //微信登录
  apiWeixinOpenLogin(p){
    return get('/api/weixinOpenLogin',p)
  },
  //绑定
  apiWeixinOpenBind(p){
    return get('/api/weixinOpenBind',p)
  },
  apiWeixinOpenUnbind(p){
    return get('api/account/weixinOpenUnbind',p)
  },
  //注册
  register(params){
    return fetch('/api/register',params)
  },
  //注册短信
  apiGetSmsCode_3(params){
    return get('/api/getSmsCode_3',params)
  },
  //登录
  apiLogin(params){
    return fetch('/api/login',params)
   },
  apiGetSmsCode_4(params){
    return get('/api/getSmsCode_4',params)
  },
  //退出
  apiLogout(params){
    return fetch('/api/logout',params)
  },
  //修改密码
  apiAccountChangePassword(params){
    return fetch('/api/account/changePassword',params)
  },
  //按短信修改密码
  apiResetPassword(params){
    return fetch('/api/resetPassword',params)
  },
  //发送邮箱验证
  apiAccountSendBindMail(params){
    return get('/api/account/sendBindMail',params)
  },
  //绑定邮箱
  apiVerifyMail(params){
    return get('/api/verifyMail',params)
  },
  //查询钱包数据
  apiAccountGetAccountMoney(params){
    return get('/api/account/getAccountMoney',params)
  },
  //设置取款密码
  apiAccountDrawPwdSet(params){
    return fetch('/api/account/drawPwdSet',params)
  },
  //添加银行卡
  apiAccountBankCardBind(params){
    return fetch('/api/account/bankCardBind',params)
  },
  //删除银行卡
  apiAccountBankCardDelete(p){
    return fetch('/api/account/bankCardDelete',p)
  },
  //申请提现
  apiAccountDrawMoney(params){
    return fetch('/api/account/drawMoney',params)
  },
  //交易明细
  apiAccountGetMoneyExchangeList(params){
    return get('/api/account/getMoneyExchangeList',params)
  },
  //钱包列表
  apiGetDrawMoneyList(p){
    return get('/api/account/getDrawMoneyList',p)
  }
};

const TalentApi = {
  //制作团队和制作人
  getProducerByPage(params){
    return get('/api/getProducerByPage',params)
  },
  //演员和模特
  getModelActorList(params){
    return get('/api/getModelActorList',params)
  },
  //演员和模特详情
  getModelActorDetail(params){
    return get('/api/getModelActorDetail',params)
  },
  //收藏演员和模特
  modelKeep(params){
    return get('/api/account/modelKeep',params)
  },
  //获取红人详情
  getFavouriteDetail(params){
    return get('/api/account/getFavouriteDetail',params)
  },
  //更新美图
  updatePhotos(params){
    return fetch('/api/account/updatePhotos',params)
  },
  //更新资料
  postFavouriteInfo(params){
    return post('/api/account/postFavouriteInfo',params)
  },
};

const activityApi = {
  //活动
  getActivityByPage(params){
    return get('/api/getActivityByPage',params)
  }
};

const publishApi = {
  //发布意向单
  postConsumerIntention(params){
    return post('/api/postConsumerIntention',params)
  },
  verifyAccountExistance(params){
    return get('/api/verifyAccountExistance',params)
  }
};

const codeApi = {
  //获取验证码
  apiGetSmsCode_1(params){
    return get('/api/getSmsCode_1',params)
  },
  apiGetSmsCode_2(params){
    return get('/api/getSmsCode_2',params)
  },
  apiGetSmsCode_3(params){
    return get('/api/getSmsCode_3',params)
  },
  apiGetSmsCode_4(params){
    return get('/api/getSmsCode_4',params)
  },
  apiAccountVerifyFormalMobileSms4(params){
    return fetch('/api/account/verifyFormalMobileSms4',params)
  }
};

const accountApi = {
  apiAccountVerifyPhoneValid(params){
    return fetch('/api/account/verifyPhoneValid',params)
  },
  apiAccountChangeMobile(params){
    return fetch('/api/account/changeMobile',params)
  },
  //查找个人信息
  apiAccountGetDetail(params){
    return get('/api/account/getDetail',params)
  },
  apiAccountEditAccount(params){
    return post('/api/account/editAccount',params)
  }
};

const projectApi = {
  //我的项目
  getConsumerIntentionList(params){
    return get('/api/customer/getConsumerIntentionList',params)
  },
  //获取详情
  getConsumerIntentionDetail(params){
    return get('/api/customer/getConsumerIntentionDetail',params)
  },
  //签署合同
  signContract(params){
    return get('/api/customer/signContract',params)
  },
  //准备支付
  prePay(params){
    return fetch('/api/customer/prePay',params)
  },
  //接受策划案
  acceptPlot(params){
    return get('/api/customer/acceptPlot',params)
  },
 //申请修改
  modifyRequest(params){
    return get('/api/customer/modifyRequest',params)
  },
  //选择版本
  choseVideoVersion(params){
    return get('/api/customer/choseVideoVersion',params)
  },
  signAttachment(params){
    return get('/api/customer/signAttachment',params)
  },
  confirmScreen(params){
    return get('/api/customer/confirmScreen',params)
  },

  /**--制片列表 详情--****/
  //制片list
  apiProducerGetConsumerIntentionList(params){
    return get('/api/producer/getConsumerIntentionList',params)
  },
  //制片详情
  apiProducerGetConsumerIntentionDetail(params){
    return get('/api/producer/getConsumerIntentionDetail',params)
  },
  //按角色查询制作人列表
  apiProducerGetRoleInfoList(params){
    return get('/api/producer/getRoleInfoList',params)
  },
  //提交报价清单
  apiProducerPostPriceAndRole(params){
    return post('/api/producer/postPriceAndRole',params)
  },
  //签署合同
  apiProducerSignContrac(params){
    return get('/api/producer/signContract',params)
  },
  //接受项目
  apiProducerConfirm(params){
    return get('/api/producer/producerConfirm',params)
  }
};

const infoDetailApi = {
  //咨询详情
  getInformationDetail(params){
    return get('/api/getInformationDetail',params)
  }
};

const userPageApi = {
  //制作人主页
  getProducerByPage(params){
    return get('/api/getProducerByPage',params)
  },
  //置顶案例
  getTopSample(params){
    return get('/api/getTopSample',params)
  },
  //获取制作人
  getProducerDetail(params){
    return get('/api/getProducerDetail',params)
  },
  //上传背景
  accountangeBackground(params){
    return fetch('/api/account/changeBackground',params)
  },
  //发布作品
  apiccountPostWorkSample(params){
    return post('/api/account/postWorkSample',params)
  },
  //x修改作品
  apiAccountGetWorkSample(params){
    return get('/api/account/getWorkSample',params)
  },
  //删除作品
  apiAccountDeleteWorkSample(params){
    return get('/api/account/deleteWorkSample',params)
  },
  //设置置顶案例
  apiAccountSetTopWorkSample(params){
    return get('/api/account/setTopWorkSample',params)
  },
  //制作人收藏
  apiAccountProducerKeep(params){
    return get('/api/account/producerKeep',params)
  },
  //获取认证标签
  getProducerTagAuth(params){
    return get('/api/account/getProducerTagAuth',params)
  },
  //提交认证标签
  postProducerTagAuth(params){
    return post('/api/account/postProducerTagAuth',params)
  }
};

const realApi = {
  //提交制作人认证
  postProducerAuth(params){
    return post('/api/account/postProducerAuth',params)
  },
  //查询制作人认证信息
  getProducerAuth(params){
    return get('/api/account/getProducerAuth',params)
  }
}

const VenueApi = {
  //分页获取场地
  getVenueByPage(params){
    return get('/api/getVenueByPage',params)
  },
  //更新场地
  postVenue(params){
    return post('/api/account/postVenue',params)
  },
  //删除场地
  deleteVenue(params){
    return get('/api/account/deleteVenue',params)
  },
  //获取场地内容
  getVenueDetail(params){
    return get('/api/getVenueDetail',params)
  },
  //收藏场地内容
  venueKeep(params){
    return get('/api/account/venueKeep',params)
  },
  //收藏场地列表
  venueKeepList(params){
    return get('/api/account/venueKeepList',params)
  },
}

const EquipmentApi = {
  //分页获取器材
  getEquipmentByPage(params){
    return get('/api/getEquipmentByPage',params)
  },
  //更新场地
  postEquipment(params){
    return post('/api/account/postEquipment',params)
  },
  //删除器材
  deleteEquipment(params){
    return get('/api/account/deleteEquipment',params)
  },
  //获取器材内容
  getEquipmentDetail(params){
    return get('/api/getEquipmentDetail',params)
  },
  //收藏器材内容
  equipmentKeep(params){
    return get('/api/account/equipmentKeep',params)
  },
  //收藏器材列表
  equipmentKeepList(params){
    return get('/api/account/equipmentKeepList',params)
  }

}
const LogoutApi = {
  //注销检查
  checkHasProject(params){
    return fetch('/api/account/checkHasProject',params)
  },
  //注销验证码
  verifySignOff(params){
    return fetch('/api/account/verifySignOff',params)
  },
//注销验证码
  signOff(params){
    return fetch('/api/account/signOff',params)
  },
}

export{
  indexApi,
  caseIndex,
  apiReg,
  TalentApi,
  activityApi,
  publishApi,
  codeApi,
  projectApi,
  infoDetailApi,
  accountApi,
  userPageApi,
  realApi,
  VenueApi,
  EquipmentApi,
  LogoutApi,
  IP
}



// WEBPACK FOOTER //
// ./src/fetch/api.js